import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './_reducers/root.reducer';

const store = configureStore({
    reducer: rootReducer
})

export default store